module.exports = {
      id: "fb-greybg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#fb-greybg",
      toString: function () {
        return this.url;
      }
    }